import React from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import firstStepPic from '../../asset/start-page-first-step-pic.png'
import { firstStepInstructionCardData } from '../../data/pageInfoCardData'
import PageWrapper from '../../components/PageWrapper'
import PageHeader from '../../components/PageHeader'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import InstructionCard from '../../components/InstructionCard'
import ImageCard from '../../components/ImageCard'
import PageNavButton from '../../components/PageNavButton'

const FirstStepPage = () => {
  const navigate = useNavigate()
  return (
    <PageWrapper>
      <Helmet>
        <title>CompareBanks</title>
      </Helmet>
      <PageContentWrapper>
        <PageHeader
          headerTitle="CompareBanks "
          workflow="Pre-Consent"
          haveMenu={false}
          isFocused={true}
          titleLabel="coampare banks : start your compare banks"
        />
        <InstructionCard {...firstStepInstructionCardData} />
        <ImageCard showPic={firstStepPic} alt="" />
      </PageContentWrapper>
      <PageNavButton
        onClickFunc={() => navigate('/procedure')}
        content="Continue"
        //isFocused={true}
        ariaLabel="Continue button, to visit next page double click here"
      />
    </PageWrapper>
  )
}

export default FirstStepPage
